<template>
<div class="propertyStatistics">
  <div class="module" v-show="false">
    <div class="item" style="width: 100%">
      <div class="title">全校资产分布</div>
      <div class="content" id="allProperty"></div>
    </div>
  </div>
  <div class="module">
    <div class="item" style="width: 49.5%">
      <div class="title">资产分类数量</div>
      <div class="content" id="classifyNumber"></div>
    </div>
    <div class="item" style="width: 49.5%">
      <div class="title">资产分类金额</div>
      <div class="content" id="classifyMoney"></div>
    </div>
  </div>
  <div class="module">
    <div class="item" style="width: 100%">
      <div class="title">历年资产购置趋势</div>
      <div class="content" id="historyMoney"></div>
    </div>
  </div>
</div>
</template>

<script>
  import axios from "axios";
  import apiConfig from "../../common/js/api_config";

  export default {
    name: "propertyStatistics",
    data() {
      return {
        staffColor: ['#1F89DF', '#49A3EC', '#6FB7F2', '#91C7AE', '#A2A860', '#91C7AE', '#EEC714', '#EEB814', '#6ABD9D'],
        classifyNumberData: [
          {
            name: '资产a',
            value: 5000
          },
          {
            name: '资产b',
            value: 3000
          }
        ],
        classifyMoneyData: [
          {
            name: '资产a',
            value: 100000
          },
          {
            name: '资产b',
            value: 20000
          }
        ]
      }
    },
    methods: {
      // 全校资产分布
      async getAllPropertyData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_zc_dqgdwzcjr')
        let dwmcArray = []
        let jeArray = []
        resp.data.data.map(item => {
          dwmcArray.push(item.dwmc)
          jeArray.push(item.je)
        })
        this.drawAllProperty(dwmcArray, jeArray)
      },
      drawAllProperty(dwmcArray, jeArray) {
        let option = {
          color: this.staffColor,
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: function (data) {
              console.log(data);
              return `${data[0].name}<br/>金额:${data[0].value}元`
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: dwmcArray,
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],
          dataZoom: [
            {
              show: true,
              start: 0,
              end: 50
            },
            {
              type: 'inside',
              start: 0,
              end: 50
            },

          ],
          series: [
            {
              name: '金额(元)',
              type: 'bar',
              barWidth: '60%',
              data: jeArray,
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0],
              },
              barMaxWidth: 20,
            },
          ]
        };
        this.allPropertyBox.setOption(option)
      },
      //资产数量
      async getClassifyNumberData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_zc_zcflsl')
        let mcArray = []
        let jeArray = []
        resp.data.data.map(item => {
          mcArray.push(item.fl)
          jeArray.push(item.sl)
        })
        this.drawClassifyNumber(mcArray,jeArray)
      },
      drawClassifyNumber (mcArray,jeArray) {
        let option = {
          color: this.staffColor,
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: mcArray,
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],
          dataZoom: [
            {
              show: true,
              start: 0,
              end: 1
            },
            {
              type: 'inside',
              start: 0,
              end: 1
            },

          ],
          series: [
            {
              name: '数量',
              type: 'line',
              barWidth: '60%',
              data: jeArray,
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0],
              },
              barMaxWidth: 20,
            },
          ]
        };
        this.classifyNumberBox.setOption(option)
      },
      // 资产金额
      async getClassifyMoneyData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_zc_zcflje')
        let mcArray = []
        let jeArray = []
        resp.data.data.map(item => {
          mcArray.push(item.fl)
          jeArray.push(item.je)
        })
        this.drawClassifyMoney(mcArray,jeArray)
      },
      drawClassifyMoney (mcArray,jeArray) {
        let option = {
          color: this.staffColor,
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: function (data) {
              console.log(data);
              return `${data[0].name}<br/>金额:${data[0].value}元`
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: mcArray,
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],
          dataZoom: [
            {
              show: true,
              start: 0,
              end: 1
            },
            {
              type: 'inside',
              start: 0,
              end: 1
            },

          ],
          series: [
            {
              name: '金额(元)',
              type: 'line',
              barWidth: '60%',
              data: jeArray,
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0],
              },

              barMaxWidth: 20,
            },
          ]
        };
        this.classifyMoneyBox.setOption(option)
      },
      // 历史

      async getHistoryMoneyData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_zc_lngzzcjr')
        function compare(property){
          return function (a,b) {
            let value1 = a[property]
            let value2 = b[property]
            return value1 - value2
          }
        }
        let data = resp.data.data.sort(compare('nf'))
        let dwmcArray = []
        let jeArray = []
        data.map(item => {
          dwmcArray.push(item.nf)
          jeArray.push(item.je)
        })
        this.drawHistoryMoney(dwmcArray, jeArray)
      },
      drawHistoryMoney (dwmcArray, jeArray) {
        let option = {
          color: this.staffColor,
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },

            formatter: function (data) {
              console.log(data);
              return `${data[0].name}<br/>金额:${data[0].value}元`
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: dwmcArray,
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],
          dataZoom: [
            {
              show: true,
              start: 0,
              end: 50
            },
            {
              type: 'inside',
              start: 0,
              end: 50
            },

          ],
          series: [
            {
              name: '金额(元)',
              type: 'line',
              barWidth: '60%',
              data: jeArray,
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0],
              },
              barMaxWidth: 20,
            },
          ]
        };
        this.historyMoneyBox.setOption(option)
      }
    },
    mounted() {
      this.allPropertyBox = this.$echarts.init(document.getElementById('allProperty'))
      this.classifyNumberBox = this.$echarts.init(document.getElementById('classifyNumber'))
      this.classifyMoneyBox = this.$echarts.init(document.getElementById('classifyMoney'))
      this.historyMoneyBox = this.$echarts.init(document.getElementById('historyMoney'))
      this.getAllPropertyData()
      this.getClassifyNumberData()
      this.getClassifyMoneyData()
      this.getHistoryMoneyData()
      window.addEventListener('resize', () => {
        this.allPropertyBox.resize()
        this.classifyNumberBox.resize()
        this.classifyMoneyBox.resize()
        this.historyMoneyBox.resize()
      })
    }
  }
</script>

<style lang="stylus" scoped>
  .propertyStatistics
    width 100%
    color #333
    .module
      width 100%
      height 350px
      margin-top 25px
      display flex
      justify-content space-between
      .item
        width 49.5%
        height 100%
        background #fff
        border-radius 10px
        overflow hidden
        position relative
        .title
          width 100%
          height 20%
          display flex
          align-items center
          justify-content center
          font-size 18px
          font-weight bold
        .content
          width 100%
          height 80%
</style>


// WEBPACK FOOTER //
// src/components/datanalysis/propertyStatistics.vue